<style lang="scss" scoped>
.slide-10 {
  background-image: url(../../../assets/module1/slide10/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 86px;
  height: calc(100% - 86px);
  padding-left: 115px;
  display: flex;
  flex-direction: column;
}
h1 {
  font-size: 77px;
  margin-bottom: 30px;
}
.left {
  display: flex;
  flex-direction: column;
}
.lead {
  color: #301f48;
  font-size: 130px;
  line-height: 1;
  margin-left: auto;
  transform: rotate(-8deg) translate(100px, 25px);
}
p {
  color: white;
}
.left p {
  max-width: 425px;
}
h2 {
  font-size: 50px;
  margin-top: 10px;
}
.right {
  margin-bottom: 37px;
  margin-left: 132px;
}
</style>

<template>
  <div class="slide-10">
    <transition name="scale" appear>
      <img
        v-show="slideIndex == 9"
        src="@/assets/module1/slide10/graphic-01.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeRight" appear>
      <h1 v-show="slideIndex == 9">{{ $t("module1.slide10.heading") }}</h1>
    </transition>
    <div class="flex align-end">
      <div class="left">
        <transition name="fadeRight" appear>
          <p
            class="delay-1"
            v-show="slideIndex == 9"
            v-html="$t('module1.slide10.paragraph')"
          ></p>
        </transition>
        <transition name="fadeRight" appear>
          <div v-show="slideIndex == 9" class="delay-2">
            <div class="lead kooky" v-html="$t('module1.slide10.lead')"></div>
          </div>
        </transition>
      </div>
      <div class="right flex-1 ">
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 9" class="delay-3">
            {{ $t("module1.slide10.paragraph2") }}
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <h2 v-show="slideIndex == 9" class="delay-4">
            {{ $t("module1.slide10.heading2") }}
          </h2>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
